import { HiShieldCheck } from "react-icons/hi2";

export const SecurityIcon = ({ width, height, color, ...props }) => (
  <HiShieldCheck
    size={width || height || 16}
    color={color || "currentColor"}
    {...props}
  />
);
